import { DateTime } from "luxon";

export const dateTimeToIso = (dt: DateTime | null) => dt?.toISO() ?? null;
export const isoToDateTime = (iso: string | null) =>
  iso ? DateTime.fromISO(iso) : null;
